<template>
  <div>
    <Head>
      <title>Postcard Editor for Direct Mail Platforms | Designer Tool</title>
      <meta
        name="description"
        content="Embed a postcard and letter design editor in your product. Users design in the browser; you get clean, print-ready HTML for Lob, PostGrid or your own press. Try it free."
      />
      <link
        rel="canonical"
        href="https://designertool.io/"
      />
      <meta
        name="robots"
        content="index,follow"
      />
    </Head>

    <LandingHeader />

    <main>
      <WelcomeHero />

      <TryTheToolSection />

      <LogoStripSection />

      <TwoWaysSection />

      <WhySection />

      <HowItWorksSection />

      <TabbedBentoSection />

      <DeveloperSnippetSection />

      <TestimonialsSection />

      <PricingSummarySection />

      <WelcomeFAQSection />

      <WelcomeCTASection />
    </main>

    <footer class="bg-gray-100">
      <FooterSection />
    </footer>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { Head } from "@inertiajs/vue3";
import LandingHeader from "@/Components/LandingHeader.vue";
import FooterSection from "@/Components/Welcome/FooterSection.vue";
import TabbedBentoSection from "@/Components/Welcome/TabbedBentoSection.vue";

import WelcomeHero from "@/Components/Welcome/WelcomeHero.vue";
import LogoStripSection from "@/Components/Welcome/LogoStripSection.vue";
import TwoWaysSection from "@/Components/Welcome/TwoWaysSection.vue";
import WhySection from "@/Components/Welcome/WhySection.vue";
import HowItWorksSection from "@/Components/Welcome/HowItWorksSection.vue";
import DeveloperSnippetSection from "@/Components/Welcome/DeveloperSnippetSection.vue";
import TestimonialsSection from "@/Components/Welcome/TestimonialsSection.vue";
import PricingSummarySection from "@/Components/Welcome/PricingSummarySection.vue";
import WelcomeFAQSection from "@/Components/Welcome/WelcomeFAQSection.vue";
import WelcomeCTASection from "@/Components/Welcome/WelcomeCTASection.vue";

import { Addon } from "@/types/addon";
import TryTheToolSection from "@/Components/Welcome/TryTheToolSection.vue";

interface Props {
  addons: Addon[];
}

defineProps<Props>();

onMounted(async () => {
  if (!("scrollBehavior" in document.documentElement.style)) {
    const smoothscroll = await import("smoothscroll-polyfill");
    smoothscroll.polyfill();
  }

  if (window.location.hash) {
    setTimeout(() => {
      const element = document.querySelector(window.location.hash);
      element?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 300);
  }
});
</script>

<style>
html {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}
</style>
